<template>
<v-row class="im-result regular" no-gutters>
    <v-col cols="6">
        <v-row no-gutters>
            <v-col cols="12" md="3" order-md="1" order-xs2 class="px-2">
                {{ item.id }}
            </v-col>
            <v-col cols="12" md="3" order-md="2" order-xs3 class="px-2">
                {{ item.country }}
            </v-col>
            <v-col cols="12" md="6" order-md="3" order-xs1 class="px-2">
                {{ item.name_real }}
            </v-col>
        </v-row>
    </v-col>
    <v-col cols="6">
        <v-row no-gutters>
            <v-col cols="12" md="6" class="px-2">
                <span v-if="item.region_real">{{ item.region_real }}</span>
            </v-col>
            <v-col cols="12" md="3" class="px-2">
                {{ item.priority }}
            </v-col>
            <v-col cols="12" md="3" class="px-2">
                {{ item.hits }}
            </v-col>
        </v-row>
    </v-col>
</v-row>
</template>

<script>
import defaults from "../utils/PropDefaults.js";

export default {
    props: {
        item: {
            type: Object,
            default: function () {
                return this.$clone(defaults.place_item)
            }
        },
    },

    methods: {
        emitClick() {
            this.$emit('click');
        },
    },

}
</script>
